// AI Persona Avatars and Information
export const AI_PERSONAS = {
  ALEC: {
    name: 'ALEC',
    fullName: 'ALEC - AI Visa Officer',
    role: 'Visa Interview Practice',
    description: 'Your AI-powered visa interview officer',
    avatar: 'https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?auto=format&fit=crop&w=400&q=80',
    credits: 25
  },
  WONG: {
    name: 'WONG',
    fullName: 'WONG - Admission Predictor',
    role: 'Admission Chances Calculator',
    description: 'AI-powered college admission probability analysis',
    avatar: 'https://images.unsplash.com/photo-1543132220-4bf3de6e10ae?auto=format&fit=crop&w=400&q=80',
    credits: 2
  },
  ASHISH: {
    name: 'Ashish',
    fullName: 'Ashish - Career Simulator',
    role: 'Career Path Visualization',
    description: 'Visualize your career journey with AI insights',
    avatar: 'https://images.unsplash.com/photo-1584940120505-117038d90b05?auto=format&fit=crop&w=400&q=80',
    credits: 2
  },
  FAITH: {
    name: 'Faith',
    fullName: 'Faith - Academic Advisor',
    role: 'Major Selection Guidance',
    description: 'Personalized academic guidance powered by AI',
    avatar: 'https://images.unsplash.com/photo-1585240975858-7264fd020798?auto=format&fit=crop&w=400&q=80',
    credits: 2
  },
  WASIF: {
    name: 'Wasif',
    fullName: 'Wasif - Essay Assistant',
    role: 'Essay Writing Assistance',
    description: 'AI-powered essay review with authenticity detection',
    avatar: 'https://images.unsplash.com/photo-1770096951056-c94a812e9fd4?auto=format&fit=crop&w=400&q=80',
    credits: 3
  }
};

export default AI_PERSONAS;
